export default "__VITE_ASSET__9186d5d8__"